import React, { useContext, useCallback } from 'react';
import isDefinedAndNotNull from '@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var TabsPropsContext = /*#__PURE__*/React.createContext();

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useTabs = function useTabs() {
  var _useContext = useContext(TabsPropsContext),
      defaultActiveTab = _useContext.defaultActiveTab,
      activeTab = _useContext.activeTab,
      forceActiveTabCentered = _useContext.forceActiveTabCentered,
      disabled = _useContext.disabled,
      id = _useContext.id,
      isVertical = _useContext.isVertical,
      manualSelection = _useContext.manualSelection,
      onChange = _useContext.onChange,
      tabs = _useContext.tabs,
      setTabs = _useContext.setTabs;

  var updateTab = useCallback(function (tabId, tabInfo) {
    setTabs(function (prevState) {
      return prevState.map(function (el) {
        if (el.id === tabId) {
          return _objectSpread(_objectSpread({}, el), tabInfo);
        }

        return el;
      });
    });
  }, [setTabs]);
  var registerTab = useCallback(function (tabInfo) {
    var tab = activeTab || defaultActiveTab;
    setTabs(function (prevState) {
      var isActive = isDefinedAndNotNull(tab) ? tab === tabInfo.id : prevState.length === 0;
      return [].concat(_toConsumableArray(prevState), [_objectSpread(_objectSpread({}, tabInfo), {}, {
        isActive: isActive
      })]);
    });
  }, [activeTab, defaultActiveTab, setTabs]);
  var unregisterTab = useCallback(function (tabId) {
    setTabs(function (prevState) {
      return prevState.filter(function (each) {
        return each.id !== tabId;
      });
    });
  }, [setTabs]);
  return {
    activeTab: activeTab,
    defaultActiveTab: defaultActiveTab,
    forceActiveTabCentered: forceActiveTabCentered,
    disabled: disabled,
    id: id,
    isVertical: isVertical,
    manualSelection: manualSelection,
    onChange: onChange,
    tabs: tabs,
    registerTab: registerTab,
    setTabs: setTabs,
    unregisterTab: unregisterTab,
    updateTab: updateTab
  };
};

export { TabsPropsContext as T, useTabs as u };
